import store from '@/store';
import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/:catchAll(.*)', redirect: '/' },

  { path: '/', component: () => import('@/views/dashboard/calfControl.vue') },
  { path: '/test', component: () => import('@/views/dashboard/test.vue') },
  // { path: '/test2', component: () => import('@/views/dashboard/test2.vue') },
  { path: '/externalFeeding', component: () => import('@/views/dashboard/externalFeeding.vue') },
  { path: '/errorlog', component: () => import('@/views/dashboard/errorLog.vue') },

  { path: '/treatments', component: () => import('@/views/dashboard/treatments/treatments.vue') },

  { path: '/calf', component: () => import('@/views/dashboard/calf/CalfList.vue') },
  { path: '/health', component: () => import('@/views/dashboard/calf/CalfDiaphragm.vue') },
  { path: '/calf/details', component: () => import('@/views/dashboard/calf/calfDetails.vue') },
  { path: '/calf/remainder', component: () => import('@/views/dashboard/calf/control/calfRemainder.vue') },
  { path: '/calf/consumption', component: () => import('@/views/dashboard/calf/control/calfConsumption.vue') },
  { path: '/calf/calfOperations', component: () => import('@/views/dashboard/calf/control/calfOperations.vue') },

  { path: '/archive', component: () => import('@/views/dashboard/archives/archiveList.vue') },
  { path: '/archive/details', component: () => import('@/views/dashboard/archives/archiveDetails.vue') },

  { path: '/specialfeeding', component: () => import('@/views/dashboard/specialfeeding/specialFeeding.vue') },

  { path: '/panel/tracking/follow', name: 'auth-plc', component: () => import('@/views/panel/services/plcTracking.vue') },
  { path: '/panel/tracking/system', name: 'auth-trackingSystem', component: () => import('@/views/panel/services/trackingSystem.vue') },
  { path: '/panel/tracking/liquid', name: 'auth-tracking3', component: () => import('@/views/panel/services/trackingLiquid.vue') },
  { path: '/panel/tracking/license', name: 'auth-license', component: () => import('@/views/panel/services/license.vue') },

  { path: '/panel/calibration/ports', name: 'auth-ports', component: () => import('@/views/panel/raspberryCalibration/portList.vue') },
  { path: '/panel/calibration/systems', name: 'auth-systems', component: () => import('@/views/panel/technicalService/systemCalibration.vue') },
  { path: '/panel/network', name: 'auth-network', component: () => import('@/views/panel/raspberryCalibration/network.vue') },

  { path: '/panel/technical/components', name: 'auth-components', component: () => import('@/views/panel/technicalService/componentControl.vue') },
  { path: '/panel/technical/baummer', name: 'auth-baummer', component: () => import('@/views/panel/technicalService/baummerControl.vue') },
  { path: '/panel/technical/stationCalibration', name: 'auth-stationCalibration', component: () => import('@/views/panel/technicalService/stationCalibration.vue') }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach(async (to, from, next) => {
  const auth = to.name?.split('-')[0] == 'auth' ? true : false;
  if (auth) {
    if (store.state.auth.authority) next();
    else router.push('/');
  } else next();
});

export default router;
